import * as React from 'react';
import { Alert, Button, Col, Form, Input, message, Row } from 'antd';
import ConfigurationService from '../../Service/ConfigurationService';
import Page from '../../Component/Page/Page';
import { useState } from 'react';
import { useParams } from 'react-router';
import { useNavigate } from "react-router-dom";
import { PASSWORD_CHANGED } from '../../Helper/BannerMessages';

interface NewPasswordFormState {
  loading: boolean;
  success: boolean,
  error?: {
    message: string;
    type: 'error'|'success';
  }
}

const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 8 },
};
const tailLayout = {
};

export default function NewPasswordForm () {
  const [redirect, setRedirect] = useState<boolean>(false);
  const [state, setState] = useState<NewPasswordFormState>({
    error: undefined,
    loading: false,
    success: false
  });

  const { loading, error } = state;
  const { token } = useParams();
  const navigate = useNavigate();

  if (redirect) {
    navigate('/login');
  }

  const onFinish = async (values: any) => {
    const { password } = values;

    setState({ ...state, loading: true, error: undefined });

    try {
      const response = await fetch(`${ConfigurationService.urls().resetPasswordNewPasswordUrl}/${token}`, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({ password: btoa(password) })
      })

      // A refused password used to be dropped: the form only looked for a 200 and said nothing otherwise
      if (!response.ok) {
        const body = await response.text();
        let reason: any = null;

        try {
          reason = body ? JSON.parse(body) : null;
        } catch (parseError) {
          reason = null;
        }

        throw new Error(typeof reason?.message === 'string'
          ? reason.message
          : `The password could not be changed (${response.status})`);
      }

      message.success(PASSWORD_CHANGED);
      setRedirect(true);
    } catch (error: any) {
      console.error(error.message);
      setState({
        success: false,
        loading: false,
        error: {
          message: error.message,
          type: 'error'
        }
      })
    }

    setState({ ...state, loading: false });
  };

  return (
    <Page title={'Password Reset'} isPublic={true} hideCounter>
      <Row style={{ paddingBottom: '20px' }}>
        <Col>
          {error && <Alert message={error.message} type="error" showIcon />}
        </Col>
      </Row>
      <Row>
        <Col>

        </Col>
      </Row>
      <Form
        {...layout}
        name="basic"
        onFinish={(values: any) => onFinish(values)}
      >
        <Form.Item
          name="password" label="New Password" hasFeedback rules={[{
            required: true,
            message: 'Please input your password!',
          }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          name="confirm" label="Confirm Password" dependencies={['password']} hasFeedback
          rules={[{
              required: true,
              message: 'Please confirm your password!',
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('The two passwords that you entered do not match!'));
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item {...tailLayout}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Page>
  );
}
